import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Comprehensive ResizeObserver error suppression
// This is a known issue with React Flow and ResizeObserver that doesn't affect functionality

// Override console.error to filter out ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  if (message.includes('ResizeObserver loop completed') || 
      message.includes('ResizeObserver loop limit exceeded')) {
    return; // Suppress these specific errors
  }
  originalConsoleError.apply(console, args);
};

// Handle global errors
const resizeObserverErrorHandler = (event) => {
  if (event.message && (
    event.message.includes('ResizeObserver loop completed') ||
    event.message.includes('ResizeObserver loop limit exceeded')
  )) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('ResizeObserver loop completed') ||
    event.reason.message.includes('ResizeObserver')
  )) {
    event.preventDefault();
    return false;
  }
});

// Also suppress ResizeObserver errors at the source
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback) {
    const wrappedCallback = (entries, observer) => {
      try {
        callback(entries, observer);
      } catch (e) {
        if (e.message && e.message.includes('ResizeObserver loop completed')) {
          // Ignore this error
          return;
        }
        throw e;
      }
    };
    super(wrappedCallback);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
